import PropTypes from 'prop-types';
import React, {Component} from 'react';
import axios from 'axios';

import ShareTokenListItem from './share_token_list_item';

const {deleteShareTokenLink, updateShareTokenLink} = window.sn;

export default class ShareTokenList extends Component {
    static propTypes = {
        shareTokens: PropTypes.array,
        onShareDelete: PropTypes.func.isRequired
    };

    handleTokenDelete = (token, i) => {
        const url = deleteShareTokenLink.replace('__id__', token.id);
        axios.delete(url).then(() => {
            if (this.props.onShareDelete) {
                this.props.onShareDelete(token, i);
            }
        });
    };

    handleTokenChange = token => {
        const url = updateShareTokenLink.replace('__id__', token.id);
        axios.put(url, token);
    };

    render() {
        const {shareTokens} = this.props;

        return (
            <div className="list-share-links text-left">
                <label>
                    <strong>Collaborators:</strong>
                </label>
                {shareTokens.map((token, i) => (
                    <ShareTokenListItem
                        token={token}
                        onDelete={this.handleTokenDelete.bind(this, token, i)}
                        key={token.id}
                        onChange={this.handleTokenChange}
                    />
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/share_content_modal/share_token_list.js